import Button from "../../theme/components/Button";

const MenuCallToActionButton = ({ callToAction }) => {
  if (!callToAction) return null;
  const { url, target, data, title } = callToAction || {};
  return (
    <div className="text-end mt-5 hide-on-mobile">
      <Button
        href={typeof url === "string" ? url : url?.route}
        appearance="input"
        className="w-auto color-primary"
        target={target}
        icon={data?.image}
      >
        {title}
      </Button>
    </div>
  );
};

export default MenuCallToActionButton;
